<template>
  <div class="app-container">
    <aside id="Navigationbar" class="sidebar">
      <nav>
        <ul>
          <li><router-link to="/orders">Orders</router-link></li>
          <li><router-link to="/inventory">Inventory</router-link></li>
          <li><router-link to="/products">Products</router-link></li>
          <li><router-link to="/settings">Settings</router-link></li>
        </ul>
      </nav>
    </aside>
    <main class="main-content">
      <div v-if="errorMessage" class="error-banner">
        {{ errorMessage }}
      </div>
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view> 
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style scoped>
.app-container {
  display: flex;
  min-height: 100vh;
}

/* Sidebar styles */
.sidebar {
  background-color: #f0f0f0;
  width: 200px;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  min-height: 100vh;
}

.sidebar nav ul {
  list-style: none;
  padding: 0;
}

.sidebar nav ul li {
  margin-bottom: 10px;
}

.sidebar nav ul li a {
  text-decoration: none;
  color: #333;
  display: block;
  padding: 8px 10px;
  border-radius: 4px;
}

.sidebar nav ul li a:hover {
  background-color: #e0e0e0;
}

/* Main content area styles */
.main-content {
  flex: 1;
  padding: 20px;
}

/* Error banner styles */
.error-banner {
  background-color: red;
  color: white;
  padding: 15px;
  text-align: center;
  position: sticky;
  top: 0;
  height: 50px;
  z-index: 1000;
}

/* Transition Styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>